export const SDK_PATH = '/sdk/terminal-sdk.js'

export interface Environment {
  id: 'sandbox' | 'production'
  label: 'Sandbox' | 'Production'
  merchantApi: string
  terminal: string
}

export const environments: readonly Environment[] = [
  {
    id: 'sandbox',
    label: 'Sandbox',
    merchantApi: 'https://sandbox-api.blytzpay.com',
    terminal: 'https://sandbox-terminal.blytzpay.com'
  },
  {
    id: 'production',
    label: 'Production',
    merchantApi: 'https://api.blytzpay.com',
    terminal: 'https://terminal.blytzpay.com'
  }
]

export function sdkScript(env: Pick<Environment, 'terminal'>): string {
  return `${env.terminal}${SDK_PATH}`
}

const PLACEHOLDERS = {
  merchantApi: (env: Environment) => env.merchantApi,
  terminal: (env: Environment) => env.terminal,
  sdkScript: (env: Environment) => sdkScript(env)
} as const

export type Placeholder = keyof typeof PLACEHOLDERS

export function applyEnvironment(text: string, env: Environment): string {
  return text.replace(
    /\{\{(merchantApi|terminal|sdkScript)\}\}/g,
    (_match, key: Placeholder) => PLACEHOLDERS[key](env)
  )
}
